/* eslint-disable @next/next/no-img-element */
// js
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
// utils
import axios from 'axios';
import { sha256 } from 'js-sha256';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { FaWhatsapp, FaWindowClose } from "react-icons/fa";
import { IoMdSend } from "react-icons/io";
import { sendUser } from '../../../services/properties';
import { trackEvent } from '../../../utils/FunctionsGlobals';
import { resolveSite2524WhatsAppUrl } from '../../../utils/site2524WhatsApp';
import { trackLead } from '../../whatsAppButton/WhatsAppButton';
import ChannelChatWidget from '../channelChat/ChannelChatWidget';
import styles from './WhatsappComponent.module.css';

const AppPhoneInput = dynamic<any>(
    () => import('../../input_phone/AppPhoneInput').then((mod) => mod.AppPhoneInput as any),
    { ssr: false }
);

const WhatsAppComponent: React.FC<{ site: any, origin?: string, codsite?: number, agenciador?: any, id_imovel?: any, open?: any, setOpen?: any, lead?: any, visita?: Boolean, managerActual?: any,delegar_ao_agenciador?: any, detailsProperties?: any}> = ({ site, origin, codsite, agenciador, id_imovel, open, setOpen, lead, visita, managerActual, delegar_ao_agenciador, detailsProperties }) => {
    const [buttons, setButtons] = useState(0);
    const [formOpen, setFormOpen] = useState(0);
    const [formFOpen, setFormFOpen] = useState(0);
    const router = useRouter();
    const [horaAtual, setHoraAtual] = useState('');
    const [nome, setNome] = useState(lead?.nome ? lead?.nome : '');
    const [email, setEmail] = useState(lead?.email ? lead?.email :'');
    const [telefone, setTelefone] = useState(lead?.telefone ? lead?.telefone :'');
    const [processando, setProcessando] = useState(false);
    const [enviado, setEnviado] = useState(false);
    const [texto, setTexto] = useState<any>();

    const renderText = (transacao?: any) => {
        if(id_imovel){
            if(visita){
                return `Olá, quero agendar uma visita ao imóvel: Link: https://${site?.site}/imovel/${id_imovel}`;
            }
            return `Olá, vi este imóvel no site. Link: https://${site?.site}/imovel/${id_imovel} você pode me dar mais informações?`;
        }
        if (site?.id) {
            if(site?.texto_botao_whats){
                return `${site?.texto_botao_whats}`;
            }
            if(site?.id == "2027"){
                if(transacao == "venda"){
                    return "Olá, estou visitando o site e gostaria de informações sobre vendas. Pode me ajudar?";
                } else {
                    return "Olá, estou visitando o site e gostaria de informações sobre locação. Pode me ajudar?";
                }
            }
            return `Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`;
        }
        return '';
    };

    useEffect(() => {
        const renderText1 = () => {
            if(id_imovel){
                if(visita){
                    return `Olá, quero agendar uma visita ao imóvel: Link: https://${site?.site}/imovel/${id_imovel}`;
                }
                return `Olá, vi este imóvel no site. Link: https://${site?.site}/imovel/${id_imovel}, pode me dar mais informações?`;
            }
            if (site?.id) {
                if(site?.texto_botao_whats){
                    return `${site?.texto_botao_whats}`;
                }
                return `Olá, estou visitando o site da ${site?.Dados?.empresa}, gostaria de um atendimento personalizado. Pode me ajudar?`;
            }
            return '';
        };

        setTexto(renderText1())
    }, [site, router, id_imovel, visita]);

    useEffect(() => {
        if(lead?.nome){
            setNome(lead?.nome)
        }
        if(lead?.email){
            setEmail(lead?.email)
        }
        if(lead?.telefone){
            setTelefone(lead?.telefone)
        }
    }, [lead]);

    useEffect(() => {
        const dataAtual = new Date();
        const hora = dataAtual.getHours();
        const minuto = dataAtual.getMinutes();
        const horaFormatada = `${hora}:${minuto < 10 ? '0' : ''}${minuto}`;
        setHoraAtual(horaFormatada);
    }, []);

    const handleChange = (event: any) => {
      setTexto(event.target.value);
    };

    const openButtons = () => {
        setButtons(1);
    };

    const closeButtons = () => {
        setButtons(0);
    };

    const openButtonsForm = () => {
        setFormOpen(1);
    };

    const closeButtonsForm = () => {
        setFormOpen(0);
        if(setOpen){
            setOpen(false)
        }
    };

    const openForm = () => {
        setFormFOpen(1);
    };

    const onChangeName = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setNome(value);
    };

    const onChangeTelephone = (value: string) => {
        setTelefone(value);
    };

    const onChangeEmail = (txt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = txt.target;
        setEmail(value);
    };

    const phoneDigits = telefone?.replace(/\D/g, '') || '';
    const phoneLengthValid = phoneDigits.length > 9 && phoneDigits.length < 17;
    const emailValid = /\S+@\S+\.\S+/.test(email);
    const canSend = nome != '' && email != '' && telefone != '' && phoneLengthValid && emailValid && !processando;
    const isSite1791 = Number(site?.id) === 1791;
    const isSite2537 = Number(site?.id) === 2537;
    const hasVenda = Number(detailsProperties?.venda) > 0 || detailsProperties?.venda === true;
    const hasAluguel = Number(detailsProperties?.aluguel) > 0 || detailsProperties?.aluguel === true;
    const transactionPhoneType: 'venda' | 'locacao' = hasAluguel && !hasVenda ? 'locacao' : 'venda';

    const cleanPhone = (phone?: string) => (phone || '').replace(/\D/g, '');
    const resolveWhatsappPhone = (
        fallbackPhone?: string,
        transaction: 'venda' | 'locacao' = transactionPhoneType
    ) => {
        if (isSite1791) {
            if (transaction === 'locacao' && hasAluguel && !hasVenda) {
                return '555184010353';
            }
            return '5551984012364';
        }

        return cleanPhone(fallbackPhone);
    };
    const buildWhatsappUrl = (
        message: string,
        fallbackPhone?: string,
        transaction: 'venda' | 'locacao' = transactionPhoneType
    ) => {
        const phone = resolveWhatsappPhone(fallbackPhone, transaction);
        if (!phone) return '#';

        const prefix = isSite1791 || managerActual?.internacional ? '' : '55';
        return resolveSite2524WhatsAppUrl(site, `https://api.whatsapp.com/send?phone=${prefix}${phone}&text=${message}`);
    };
    const defaultSitePhone = isSite2537
        ? site?.Dados?.tel3 || site?.Dados?.tel1 || site?.Dados?.tel2
        : site?.Dados?.tel1 || site?.Dados?.tel2;
    const defaultManagerPhone =
        managerActual?.telefone ||
        managerActual?.telefone_2 ||
        defaultSitePhone;
    const defaultVendaPhone = isSite2537
        ? site?.Dados?.tel3 || site?.Dados?.tel2 || site?.Dados?.tel1
        : site?.Dados?.tel2 || site?.Dados?.tel1;
    const defaultAnyPhone =
        managerActual?.telefone ||
        managerActual?.telefone_2 ||
        defaultSitePhone ||
        site?.Dados?.tel3 ||
        site?.Dados?.tel4;
    const whatsappLocacaoUrl = buildWhatsappUrl(
        renderText("locacao"),
        defaultManagerPhone,
        'locacao'
    );
    const whatsappVendaUrl = buildWhatsappUrl(
        renderText("venda"),
        managerActual?.telefone || managerActual?.telefone_2 || defaultVendaPhone,
        'venda'
    );
    const whatsappVendaUrl2 = buildWhatsappUrl(
        renderText("venda"),
        managerActual?.telefone || managerActual?.telefone_3 || defaultVendaPhone,
        'venda'
    );
    const whatsappTextoUrl = buildWhatsappUrl(
        encodeURIComponent(texto),
        defaultManagerPhone,
        transactionPhoneType
    );
    const whatsappDefaultUrl = buildWhatsappUrl(
        renderText(),
        defaultAnyPhone,
        transactionPhoneType
    );

    const validaSendUser = async () => {
        if (nome != '' && email != '' && telefone != '') {
            const phone = telefone.replace(/[^0-9]/g, '');
            const verifica = isPhoneNumberValid(phone)
            var re = /\S+@\S+\.\S+/;
            if (phone.length > 9 && phone.length < 17 && (site?.internacional || phone.length < 12) && verifica) {
                if (re.test(email) == true) {
                    if(!processando){
                        setProcessando(true);
                        actionSendUser();
                    }
                } else {
                    alert('Preencha um email válido!');
                }
            } else {
                alert('Preencha um número de telefone válido!');
            }
        } else {
            alert(
                'Preencha todos os campos do formulário para enviar sua mensagem!'
            );
        }
    };

    function isPhoneNumberValid(phoneNumber: string): boolean {
        // Remove todos os caracteres não numéricos
        const cleanedNumber = phoneNumber.replace(/\D/g, '');

        // Verifica se todos os caracteres são iguais
        const allEqual = new Set(cleanedNumber).size === 1;

        // Retorna true se não forem todos iguais
        return !allEqual;
      }

    function horaAtual1() {
        const dataAtual = new Date();
        const hora = dataAtual.getHours();
        const minuto = dataAtual.getMinutes();
        const horaFormatada = `${hora}:${minuto < 10 ? '0' : ''}${minuto}`;
        return horaFormatada
    }

    const actionSendUser = async () => {
        const getSendUser = await sendUser(
            site?.internacional ? true : false,
            "",
            "",
            "",
            "",
            JSON.stringify(texto),
            JSON.stringify(nome),
            JSON.stringify(email),
            JSON.stringify(telefone),
            id_imovel ? id_imovel : 0,
            agenciador && delegar_ao_agenciador ? agenciador : 0,
            origin || "",
            codsite || 0,
            "",
            delegar_ao_agenciador ? 1 : 0
        );

        if(getSendUser?.atendimento?.id_cliente){
            const user = {
                nome,
                telefone,
                email,
            };

            localStorage.setItem('user', JSON.stringify(user));

            if (site?.tag_google_head || site?.google_analytics_head) {
                    const eventData = {
                    source: "blog",
                    client_id: getSendUser?.atendimento?.id_cliente,
                    lead_name: nome,
                    lead_email: email,
                    lead_phone: telefone,
                    // ⚠️ evite enviar PII (nome, email, telefone) para GA/GA4
                };

                trackEvent("generate_lead", eventData);
                trackEvent("lead_submit_success", eventData);
            }

            const getCookie = (name: string) =>
                document.cookie
                .split('; ')
                .find((row) => row.startsWith(name + '='))
            ?.split('=')[1] || ''

            if (site?.fb_token_pixel && site?.fb_id_pixel) {
                // Defina seu access token e ID do Pixel do Facebook
                const accessToken = site?.fb_token_pixel;
                const pixelId = site?.fb_id_pixel;
                const currentTimestampInSeconds = Math.floor(new Date().getTime() / 1000);
                const normalizedName = nome.trim().toLowerCase();
                const normalizedEmail = email.trim().toLowerCase();
                const normalizedPhone = telefone.replace(/\D/g, ''); // Apenas números

                // Hash dos dados
                const hashNome = sha256(normalizedName);
                const hashEmail = sha256(normalizedEmail);
                const hashTelefone = sha256(normalizedPhone);
                const fbc = getCookie('_fbc')
                const fbp = getCookie('_fbp')

                let clientIpAddress: string
                try {
                    const res6 = await axios.get<{ ip: string }>(
                    'https://api6.ipify.org?format=json'
                    )
                    clientIpAddress = res6.data.ip
                } catch {
                    const res4 = await axios.get<{ ip: string }>(
                    'https://api.ipify.org?format=json'
                    )
                    clientIpAddress = res4.data.ip
                }

                // Dados do evento
                const eventData = [
                    {
                    event_name: 'Lead',
                    event_time: currentTimestampInSeconds,
                    action_source: 'website',
                    event_source_url: 'https://' + site?.site,
                    user_data: {
                        fn: [hashNome],
                        em: [hashEmail],
                        ph: [hashTelefone],
                        fbc: fbc || undefined,
                        fbp: fbp || undefined,
                        client_ip_address: clientIpAddress
                    }
                }];

                axios.post(
                    `https://graph.facebook.com/v12.0/${pixelId}/events?access_token=${accessToken}`,
                    { data: eventData }
                )
                    .then(response => {
                    console.log('Evento registrado com sucesso:', response.data);
                    })
                    .catch(error => {
                    console.error('Erro ao registrar evento:', error?.response?.data || error.message);
                });
            }
        }

        setFormFOpen(0)
        setFormOpen(0)
        setEnviado(true)
        setProcessando(false);
        if(setOpen){
            setOpen(false)
        }
    };

    const renderFloatingWhatsappIcon = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1219.547 1225.016"
            className={site?.id == 1874 || site?.id == 2355 ? styles.svg_whats1 : styles.svg_whats}
        >
            <path fill="#E0E0E0" d="M1041.858 178.02C927.206 63.289 774.753.07 612.325 0 277.617 0 5.232 272.298 5.098 606.991c-.039 106.986 27.915 211.42 81.048 303.476L0 1225.016l321.898-84.406c88.689 48.368 188.547 73.855 290.166 73.896h.258.003c334.654 0 607.08-272.346 607.222-607.023.056-162.208-63.052-314.724-177.689-429.463zm-429.533 933.963h-.197c-90.578-.048-179.402-24.366-256.878-70.339l-18.438-10.93-191.021 50.083 51-186.176-12.013-19.087c-50.525-80.336-77.198-173.175-77.16-268.504.111-278.186 226.507-504.503 504.898-504.503 134.812.056 261.519 52.604 356.814 147.965 95.289 95.36 147.728 222.128 147.688 356.948-.118 278.195-226.522 504.543-504.693 504.543z"/>
            <path fill={site?.id == 2470 ? "#928f88" : "#20b038"} d="M27.875 1190.114l82.211-300.18c-50.719-87.852-77.391-187.523-77.359-289.602.133-319.398 260.078-579.25 579.469-579.25 155.016.07 300.508 60.398 409.898 169.891 109.414 109.492 169.633 255.031 169.57 409.812-.133 319.406-260.094 579.281-579.445 579.281-.023 0 .016 0 0 0h-.258c-96.977-.031-192.266-24.375-276.898-70.5l-307.188 80.548z"/><image overflow="visible" opacity=".08" transform="translate(270.984 291.372)"/><path fillRule="evenodd" clipRule="evenodd" fill="#FFF" d="M462.273 349.294c-11.234-24.977-23.062-25.477-33.75-25.914-8.742-.375-18.75-.352-28.742-.352-10 0-26.25 3.758-39.992 18.766-13.75 15.008-52.5 51.289-52.5 125.078 0 73.797 53.75 145.102 61.242 155.117 7.5 10 103.758 166.266 256.203 226.383 126.695 49.961 152.477 40.023 179.977 37.523s88.734-36.273 101.234-71.297c12.5-35.016 12.5-65.031 8.75-71.305-3.75-6.25-13.75-10-28.75-17.5s-88.734-43.789-102.484-48.789-23.75-7.5-33.75 7.516c-10 15-38.727 48.773-47.477 58.773-8.75 10.023-17.5 11.273-32.5 3.773-15-7.523-63.305-23.344-120.609-74.438-44.586-39.75-74.688-88.844-83.438-103.859-8.75-15-.938-23.125 6.586-30.602 6.734-6.719 15-17.508 22.5-26.266 7.484-8.758 9.984-15.008 14.984-25.008 5-10.016 2.5-18.773-1.25-26.273s-32.898-81.67-46.234-111.326z"/>
            <path fill="#FFF" d="M1036.898 176.091C923.562 62.677 772.859.185 612.297.114 281.43.114 12.172 269.286 12.039 600.137 12 705.896 39.633 809.13 92.156 900.13L7 1211.067l318.203-83.438c87.672 47.812 186.383 73.008 286.836 73.047h.255.003c330.812 0 600.109-269.219 600.25-600.055.055-160.343-62.328-311.108-175.649-424.53zm-424.601 923.242h-.195c-89.539-.047-177.344-24.086-253.93-69.531l-18.227-10.805-188.828 49.508 50.414-184.039-11.875-18.867c-49.945-79.414-76.312-171.188-76.273-265.422.109-274.992 223.906-498.711 499.102-498.711 133.266.055 258.516 52 352.719 146.266 94.195 94.266 146.031 219.578 145.992 352.852-.118 274.999-223.923 498.749-498.899 498.749z"/>
        </svg>
    );

    const quickWhatsappActions = [
        site?.id == 2473
            ? {
                key: 'terceiro',
                href: whatsappVendaUrl2,
                label: site?.Dados?.tel3_nome || 'Atendimento 3'
            }
            : null,
        {
            key: 'locacao',
            href: whatsappLocacaoUrl,
            label:
                managerActual?.nome ||
                site?.Dados?.tel1_nome ||
                managerActual?.telefone ||
                managerActual?.telefone_2 ||
                'Locacao'
        },
        {
            key: 'venda',
            href: whatsappVendaUrl,
            label: site?.Dados?.tel2_nome || 'Venda'
        }
    ].filter(
        (item): item is { key: string; href: string; label: string } =>
            Boolean(item?.href && item.href !== '#' && item.label)
    );

    return (
        site?.id != "105" && site?.id != "664" && site?.id != "2245" ?
            <>
            {Number(site?.id) === 2439 ? <ChannelChatWidget /> : null}
            <div className={site?.id == "1893" ? styles.logo_whatsapp2 : styles.logo_whatsapp}>
                { site?.transacoes?.length == 2 && site?.Dados?.tel1_whats && site?.Dados?.tel2_whats && site?.Dados?.tel1_nome && site?.Dados?.tel2_nome && site?.id != "1722" ?
                    <>
                        { !buttons && !open ?
                            <div className={styles.logo_button} onClick={() => openButtons()}>
                                {renderFloatingWhatsappIcon()}
                            </div>
                        :
                        <div className={site?.id == "1893" ? styles.venda_menu_alt : styles.venda_menu}>
                            {quickWhatsappActions.map((action) => (
                                <a
                                    key={action.key}
                                    className={styles.venda}
                                    onClick={() => {closeButtons();trackLead(site, {});}}
                                    href={action.href}
                                    data-no-quicklink
                                    data-no-instant
                                    data-no-prefetch
                                    rel="nofollow"
                                >
                                    {action.label}
                                </a>
                            ))}
                        </div> }
                    </>
                    :
                    site?.formulario_whats ?
                    <>
                        { !formOpen && !open ?
                            <div className={styles.logo_button} onClick={() => openButtonsForm()} title="Atendimento Personalizado" data-gtm-text="Atendimento Personalizado">
                                {renderFloatingWhatsappIcon()}
                            </div>
                        :
                        !formFOpen ?
                            <>
                                <div className={styles.card_form}>
                                    <div className={styles.card_head}>
                                        <span className={styles.header_header}>
                                            <div className={styles.whats_header}><FaWhatsapp size={25}/></div>
                                            <div className={styles.whats_header}><p>{site?.titulo}</p></div>
                                        </span>
                                        <div className={styles.whats_header}><FaWindowClose className={styles.button_exit} size={25} onClick={() => closeButtonsForm()} cursor={"pointer"}/></div>
                                    </div>
                                    <div className={styles.card_menssage}>
                                        <p className={styles.mensagem_whats}>Olá <span>{horaAtual}</span></p>
                                        <p className={styles.mensagem_whats}>Está precisando de ajuda? <span>{horaAtual}</span></p>
                                        <p className={styles.mensagem_whats}>Entre em contato via WhatsApp <span>{horaAtual}</span></p>
                                        {enviado ?
                                            <>
                                                <p className={styles.mensagem_whats_reposta}>{texto}<span>{horaAtual1()}</span></p>
                                                {site?.id != "1784" && site?.id != "1722" ?
                                                    <p className={styles.mensagem_whats}>Por favor conclua o envio da mensagem no WhatsApp e assim que possível vamos retornar o contato.<span>{horaAtual1()}</span></p>
                                                :
                                                    <p className={styles.mensagem_whats}>Recebemos sua mensagem, assim que possível vamos retornar seu contato.<span>{horaAtual1()}</span></p>
                                                }
                                                {site?.id == "1784" || site?.id == "1722" ?
                                                    null
                                                :
                                                <div className={styles.card_send}>
                                                    <a
                                                        className={styles.button_more_photo}
                                                        href={whatsappTextoUrl}
                                                        onClick={async (e) => {
                                                            e.preventDefault(); // Evita o redirecionamento automático

                                                            trackLead(site, null); // 🔥 Registra o evento Lead

                                                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                                            setTimeout(() => {
                                                                window.open(whatsappTextoUrl,
                                                                "_blank"
                                                              );
                                                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                                          }}
                                                        rel="noreferrer"
                                                    >
                                                        Enviar Mensagem
                                                    </a>
                                                </div>
                                                }
                                            </>
                                        : null}
                                    </div>
                                    {!enviado ?
                                        <div className={styles.card_send}>
                                            <div className={styles.mensagem_send}>
                                                <textarea
                                                    value={texto} // Define o valor do textarea como o valor do estado "texto"
                                                    onChange={handleChange} // Configura a função de manipulação de mudanças
                                                    className={styles.text_area_send}
                                                ></textarea>
                                            </div>
                                            <div className={styles.enviar_send}>
                                                <IoMdSend size={30} onClick={() => openForm()}/>
                                            </div>
                                        </div>
                                    : null}
                                </div>
                            </>
                        :
                            <>
                            <div className={styles.card_formF}>
                                <div className={styles.card_head}>
                                    <span className={styles.header_header}>
                                        <div className={styles.whats_header}><FaWhatsapp size={25}/></div>
                                        <div className={styles.whats_header}><p>{site?.titulo}</p></div>
                                    </span>
                                    <div className={styles.whats_header}><FaWindowClose className={styles.button_exit} size={25} onClick={() => closeButtonsForm()}/></div>
                                </div>
                                <div className={styles.card_menssage_form}>
                                    <div className={styles.form}>
                                        <input
                                            className={styles.input}
                                            placeholder="Nome"
                                            value={nome}
                                            onChange={onChangeName}
                                        />
                                        <AppPhoneInput
                                            id="Telefone_id"
                                            value={telefone}
                                            onChange={onChangeTelephone}
                                            placeholder="Telefone"
                                            defaultCountry="BR"
                                            width_max={90}
                                            inputHeight={40}
                                            limitMaxLength={true}
                                            inputClassName={styles.input}
                                            semPais={!site?.internacional ? true : false}
                                            includeCountryCode={site?.internacional ? true : false}
                                        />
                                        <input
                                            className={styles.input}
                                            placeholder="Email"
                                            value={email}
                                            onChange={onChangeEmail}
                                        />
                                        <div className={styles.adjust_checkbox}>
                                            <div className={styles.description_form}>
                                                Ao enviar concordo com os
                                                <Link prefetch={false} href="/termos">
                                                    <div className={styles.terms}>
                                                        termos de uso
                                                    </div>
                                                </Link>
                                                e
                                                <Link prefetch={false} href="/politica">
                                                    <div className={styles.terms}>
                                                        política de privacidade
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                        {!canSend ?
                                            <div
                                                className={
                                                    canSend ? styles.button_more_photo : styles.action_disabled
                                                }
                                                onClick={validaSendUser}
                                            >
                                                Enviar Mensagem
                                            </div> :
                                            <a
                                                className={
                                                    canSend ? styles.button_more_photo : styles.action_disabled
                                                }
                                                href={whatsappTextoUrl}
                                                onClick={async (e) => {
                                                    e.preventDefault(); // Evita o redirecionamento automático

                                                    await validaSendUser(); // 🔥 Aguarda a validação antes de continuar

                                                    trackLead(site, null); // 🔥 Registra o evento Lead

                                                    // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                                                    setTimeout(() => {
                                                    window.open(whatsappTextoUrl,
                                                        "_blank"
                                                    );
                                                    }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                                                }}
                                                rel="noreferrer"
                                            >
                                                Enviar Mensagem
                                            </a>
                                        }
                                    </div>
                                </div>
                            </div>
                        </>
                        }
                    </>
                    :
                    <a
                        rel="noopener noreferrer"
                        href={whatsappDefaultUrl}
                        onClick={async (e) => {
                            e.preventDefault(); // Evita o redirecionamento automático

                            trackLead(site, null); // 🔥 Registra o evento Lead

                            // 🔹 Garante que o evento seja enviado antes de abrir o WhatsApp
                            setTimeout(() => {
                              window.open(
                                whatsappDefaultUrl,
                                "_blank"
                              );
                            }, 300); // Pequeno atraso de 300ms para o evento ser registrado
                          }}
                        title='Clique para conversar pelo WhatsApp'
                        className={styles.logo_button}
                    >
                        {renderFloatingWhatsappIcon()}
                    </a>
                }
            </div>
            </>
        : null
    );
};

export default WhatsAppComponent;
